// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"b2a72a7f","121":"000867b2","163":"2047336d","251":"a57c10ef","276":"97db391e","405":"e2192627","420":"4cd7a8b2","460":"649e2c7b","606":"32d2e54a","693":"ea808352","767":"4083b85a","848":"1543b7c0","916":"31f873b7"}[chunkId] + ".chunk.js";
};